import React, { Component } from "react";
import { message } from "antd";
import F from "../../Functions";
import axios from "axios";
import EAProfile from "./ea";
import LSPProfile from "./lsp";
import AgencyManagerProfile from "./agency_manager";
import DefaultProfile from "./default";
import Cookies from "js-cookie";
import Crop_modal from "./crop_modal";
import "./profile.css"
import { AGENCY_MANAGER, SELECT_TIMEZONE } from "../../utils/Constants";

let available_hours = [];
for (let i = 7; i < 12; i++) {
  available_hours.push({
    value: i + ":00 am",
    checked: false,
  });
  available_hours.push({
    value: i + ":30 am",
    checked: false,
  });
}
available_hours.push({
  value: "12:00 pm",
  checked: false,
});
for (let i = 1; i < 8; i++) {
  available_hours.push({
    value: i + ":00 pm",
    checked: false,
  });
  available_hours.push({
    value: i + ":30 pm",
    checked: false,
  });
}

class Profile extends Component {
  state = {
    loading: true,
    loggedin: this.props.auth.user,
    user: {
      address_update: false,
    },
    agency: {},
    card: {
      card_number: "",
      exp_month: "",
      exp_year: "",
      cvc: "",
    },
    change_payment_method: false,
    appointment_hours: {
      Sunday: JSON.parse(JSON.stringify(available_hours)),
      Monday: JSON.parse(JSON.stringify(available_hours)),
      Tuesday: JSON.parse(JSON.stringify(available_hours)),
      Wednesday: JSON.parse(JSON.stringify(available_hours)),
      Thursday: JSON.parse(JSON.stringify(available_hours)),
      Friday: JSON.parse(JSON.stringify(available_hours)),
      Saturday: JSON.parse(JSON.stringify(available_hours)),
    },
    has_calendly: false,
    calendly_event_types: [],
    fileAttributes: {
      profile_pic: [],
      agency_photo: [],
    },
    tempfileAttributes: {
      profile_pic: [],
      agency_photo: [],
    },
    fileAttributesCurrentSelected: "",
    cropModalOpen: false,

    //  schedule mettings
    schedule_meetings: [],
    // folloup_meetings:[],
    // prospect_meetings:[],

  };
  componentDidMount = () => {
    this.loadingData();

    if (this.state.loggedin.user_type === "EA" || this.state.loggedin.user_type === "LSP") {
      // this.loadingSchedulingData();
    }
    // this.loadingSchedulingData();
  };

  // get API of Scheduled list
  loadingSchedulingData = async () => {
    // const { loggedin } = this.state;
    try {
      this.setState({ loading: true });
      const { data } = await axios.get(`/api/meeting/links/owner/staff/bulk/fetch`, {
        // params,
      });
      // console.log("data scheduling",data)
      this.setState({
        schedule_meetings: data.all_meetings,
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ loading: false });
    }
  };

  // create (POST and put Request)  scheduling list
  ScheduleListFunc = async () => {
    // filter the new schedules for post API requests
    const newScheduleListAPIDataArr = this.state.schedule_meetings
      .filter(
        (item) =>
          item.meeting_title && item.meeting_link && !item.linkError && !item.id && (item.followup || item.prospect || item.review)
      )
      .map((item) => ({
        meeting_title: item.meeting_title,
        meeting_link: item.meeting_link,
        followup: item.followup,
        prospect: item.prospect,
        review: item.review,
      }));
    // filter the existing schedules for put request
    const oldScheduleListAPIDataArr = this.state.schedule_meetings
      .filter(
        (item) =>
          item.meeting_title && item.meeting_link && !item.linkError && item.id && (item.followup || item.prospect || item.review)
      )
      .map((item) => ({
        meeting_title: item.meeting_title,
        meeting_link: item.meeting_link,
        id: item.id,
        followup: item.followup,
        prospect: item.prospect,
        review: item.review,
      }));

    if (newScheduleListAPIDataArr.length > 0) {
      try {
        this.setState({ loading: true });
        const res = await axios.post(
          "/api/meeting/links/bulk/upload",
          newScheduleListAPIDataArr
        );
        if (res.data.success) {
          // message.success(res.data.message);
          // return true;
        } else {
          message.error(res.data.error_response);
          // return false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.setState({ loading: false });
      }
    }
    if (oldScheduleListAPIDataArr.length > 0) {
      try {
        this.setState({ loading: true });
        const res = await axios.put(
          "/api/meeting/links/bulk/update",
          oldScheduleListAPIDataArr
        );
        if (res.data.success) {
          // message.success(res.data.message);
          // return true;
        } else {
          message.error(res.data.error_response);
          // return false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.setState({ loading: false });
      }
    }
  };

  // Delete Schedule list (PUT Request) 
  deleteSchedule = async (deleteSchedulueId) => {
    if (deleteSchedulueId) {
      try {
        const res = await axios.put("/api/meeting/links/bulk/delete", [deleteSchedulueId])

        if (res.data.success) {
          message.success(res.data.message)
        } else {
          message.error(res.data.error_response)
        }

      } catch (error) {
        message.error(error.error_response)
      }
    }
  }

  loadingData = () => {
    const { loggedin } = this.state;

    this.setState({ loading: true });

    let user_id = loggedin.id;
    axios.get("/api/users/" + user_id).then((res) => {
      if (res.data.user_type === "EA") {
        let agency_id = null;
        if (
          res.data.user_agency_assoc &&
          res.data.user_agency_assoc.length > 0
        ) {
          agency_id = res.data.user_agency_assoc[0].agency_id || null;
        }

        if (agency_id) {
          this.setState({ loading: true });
          axios
            .get("/api/agencies/" + agency_id)
            .then((res) => {
              this.setState({ agency: res.data });
            })
            .finally(() => this.setState({ loading: false }));
        }
      }

      if (res.data.appointment_hours) {
        let appointment_hours = this.state.appointment_hours;  // NOSONAR
        const appointment_hours_arr = JSON.parse(res.data.appointment_hours);
        for (var day in appointment_hours) {
          for (let i = 0; i < appointment_hours[day].length; i++) {
            if (
              appointment_hours_arr[day].indexOf(
                appointment_hours[day][i].value
              ) >= 0
            ) {
              appointment_hours[day][i].checked = true;
            }
          }
        }
        this.setState({
          appointment_hours,
        });
      }

      res.data.password = "";

      if (res.data.calendly_access_token) {
        axios.get("/api/calendly/v2/get_event_types").then((res) => {
          if (res.data.success) {
            this.setState({
              calendly_event_types: res.data.data.collection,
              // adding here new code
              has_calendly: true,
            });
          }
        });
      }

      this.setState({
        loading: false,
        user: res.data,
      });
    });
  };
  update_appointment_hours = (day, hour_index, value) => {
    let { appointment_hours } = this.state;
    appointment_hours[day][hour_index].checked = value;
    this.setState({ appointment_hours });
  };
  updateField = (name, val) => {
    const { user } = this.state;
    F.log("User Updation = > ", user);
    user[name] = val;
    F.log(`User = > ${user[name]} : ${val}`);
    this.setState({ user });
  };
  updateAgencyField = (name, val) => {
    const { agency } = this.state;
    agency[name] = val;
    this.setState({ agency });
  };
  updateCCField = (name, val) => {
    const { card } = this.state;
    card[name] = val;
    this.setState({ card });
  };
  update = () => {
    const { user, card, agency, loggedin } = this.state;
    // this.setState({ loading: true });
    F.log(this.state);
    if (
      card.card_number !== "" &&
      card.cvc !== "" &&
      card.exp_month !== "" &&
      card.exp_year !== ""
    ) {
      window.Stripe.setPublishableKey(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

      window.Stripe.createToken(
        {
          number: card.card_number,
          cvc: card.cvc,
          exp_month: card.exp_month,
          exp_year: card.exp_year,
        },
        (status, response) => {
          const stripe_token = response.id;
          if (response.error) {
            message.error(response.error.message);
            this.setState({ loading: false });
          } else {
            axios
              .post("/api/stripe/add_card", { stripe_token })
              .then((res) => {
                message.success(
                  F.translate(`Payment method has been updated.`)
                );
                this.updateUserInfo();
              })
              .catch(() => {
                // eslint-disable-next-line no-useless-escape
                message.error(F.translate(`Can\'t update payment method.`));
                this.setState({ loading: false });
              });
          }
        }
      );
    } else {
      this.updateUserInfo();
    }
  };

  validateScheduleMeetings = () => {

    const hasEmptyFieldsOrInvalidLinks = this.state.schedule_meetings.some(
      (row) => !row.meeting_title || !row.meeting_link || row.linkError
    );

    if (hasEmptyFieldsOrInvalidLinks) {
      // message.error("Please fill in all fields and correct errors");
      message.error("Scheduling title & valid link is required with at least one call type selected");
      return;
    }

    const invalidRows = this.state.schedule_meetings.some(
      (item) => !item.followup && !item.prospect && !item.review
    );
    if (invalidRows) {
      message.error("Please check at least one checkbox in each row.");
      return false;
    }
    return true;
  };

  updateUserInfo = async () => {
    const { user, card, agency, loggedin, fileAttributes } = this.state;

    const isValidate = F.validateUserProfileFields(user, agency);

    // Validate schedule meetings before calling ScheduleListFunc
    if (this.state.schedule_meetings.length > 0) {
      if (!this.validateScheduleMeetings()) {
        this.setState({ loading: false });
        return;
      }
    }

    if (isValidate) {
      let appointment_hours = {
        Sunday: [],
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: [],
      };

      var appointment_hours_found = false;
      for (var day in this.state.appointment_hours) {
        for (let i = 0; i < this.state.appointment_hours[day].length; i++) {
          const hour = this.state.appointment_hours[day][i];
          if (hour.checked) {
            appointment_hours[day].push(hour.value);
            appointment_hours_found = true;
          }
        }
      }

      if (!appointment_hours_found) {
        appointment_hours = null;
      } else {
        appointment_hours = JSON.stringify(appointment_hours);
      }
      F.log("User before Update = > ", user);
      this.setState({ loading: true });

      if (!user.timezone && user.user_type != AGENCY_MANAGER) {
        this.setState({ loading: false });
        message.error(SELECT_TIMEZONE);
        return;
      }

      try {
        await axios.put("/api/users/" + user.id, {
          first_name: user.first_name,
          last_name: user.last_name,
          email: user.email,
          // phone: user.phone,
          phone:
            user.user_type !== "LSP"
              ? F.removeFormatterFromPhoneNumber(user.phone)
              : user.phone,
          // mobile_number: user.mobile_number,
          mobile_number:
            user.user_type !== "LSP"
              ? F.removeFormatterFromPhoneNumber(user.mobile_number)
              : user.mobile_number,
          company_name: agency != null ? agency.name : user.company_name,
          carrier: user.carrier,
          home_underlying_limit: user.home_underlying_limit
            ? user.home_underlying_limit
            : "",
          auto_underlying_limit: user.auto_underlying_limit
            ? user.auto_underlying_limit
            : "",
          address: [
            user.street_one,
            user.street_two,
            user.city,
            user.state,
            user.zip_code,
            user.country,
          ]
            .filter((value) => value)
            .join(", "),
          street_one: user.street_one,
          street_two: user.street_two,
          city: user.city,
          state: user.state,
          zipcode: user.zipcode,
          jobs: user.jobs,
          timezone: user.timezone,
          default_date: user.default_date,
          language: user.language,
          manual_microsoft_enable: user.manual_microsoft_enable,
          email_cron_notification: user.email_cron_notification,
          microsoft_rs_setup_appointment: user.microsoft_rs_setup_appointment,
          microsoft_vo_setup_appointment: user.microsoft_vo_setup_appointment,
          email_game_notification: user.email_game_notification,
          email_sale_notification: user.email_sale_notification,
          minimum_liability_limits: user.minimum_liability_limits,
          virtual_link: user.virtual_link,
          appointment_hours: appointment_hours,
          calendly_rs_setup_appointment: user.calendly_rs_setup_appointment,
          calendly_vo_setup_appointment: user.calendly_vo_setup_appointment,
          minimum_liability_limits_ext: user.minimum_liability_limits_ext,
        });
        // Scheduling API call for scheduling_meetings list 
        await this.ScheduleListFunc();
        let res_upload = [];
        Object.keys(fileAttributes).forEach((key) => {
          let form = new FormData();

          if (fileAttributes[key] && fileAttributes[key].length) {
            form.append('file', fileAttributes[key][0])
            form.append('content_type', fileAttributes[key][0].type)
            form.append('upload_type', key)
            form.append('user_id', user.id)
            form.append('agency_id', agency.id)

            res_upload.push(new Promise((res, rej) => {

              axios.put('/api/upload_dp_or_agency_azure', form).then(e => {
                if (e.data && e.data.success) {
                  res()
                } else {
                  rej(e.data.message)
                }
              }).catch(err => {
                rej(err.message)
              })

            }))
          }


        })




        // this.setState({ loading: false });

        Cookies.set(
          "user_info",
          JSON.stringify({
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            id: user.id,
            user_type: user.user_type,
            jobs: user.jobs,
            default_date: user.default_date,
            last_login: user.last_login,
            language: user.language,
            agency_id: user.user_agency_assoc
              ? user.user_agency_assoc[0]
                ? user.user_agency_assoc[0].agency_id
                : null
              : null,
          }),
          {
            secure: true,           //  HTTPS only
            sameSite: 'Lax',        // Add this — fixes the scan finding
            path: '/',              // explicit path
          }
        );
        // this.props.auth.refresh();

        if (user.password !== "") {
          await axios.post("/api/update_password", {
            password: user.password,
          });
          message.success(
            F.translate(`Password has been updated successfully.`)
          );
        }

        // if(res_upload.length){
        //   Promise.allSettled(res_upload).then(()=>{
        //     message.success(
        //       F.translate(`Profile has been updated successfully.`)
        //     )
        //     // this.props.history.push("/dashboard");
        //   }).catch(err=> message.error(err))
        // }
        // else{
        //     message.success(
        //       F.translate(`Profile has been updated successfully.`)
        //     )

        //   setTimeout(() => window.location.reload(), 1000);
        //   // this.props.history.push("/dashboard");
        // }

        // if (loggedin.language !== user.language) {
        // }

        // setTimeout(() => window.location.reload(), 1000);

        if (
          user.user_type === "EA" &&
          this.state.agency &&
          this.state.agency.id
        ) {
          await axios.put("/api/agencies/" + this.state.agency.id, {
            name: agency.name,
            address: user.address,
          });
          if (user.address_update) {
            await axios.put("/api/nullify_bfiles_by_agency_id", {
              agency_id: this.state.agency.id,
            });
          }
        }
        if (res_upload.length) {
          await Promise.allSettled(res_upload);
          message.success(F.translate(`Profile has been updated successfully.`));
          // this.props.history.push("/dashboard");
        } else {
          message.success(F.translate(`Profile has been updated successfully.`));
          // this.props.history.push("/dashboard");      
        }

      } catch (error) {
        if (!error.response.data.success) {
          message.error(error.response.data.error_response)
        } else {
          message.error("Something went wrong");
        }
      } finally {
        //commented code for testing
        setTimeout(() => window.location.reload(), 300);
        this.setState({ loading: false });
      }



      // if ((user.user_type === "EA" || user.user_type === "LSP") && user.rs_manual_microsoft !== "" && user.vo_manual_microsoft !== "") {
      //   axios.post("/api/msbooking/manual_entry", {
      //     manual_microsoft_enable: user.manual_microsoft_enable,
      //     rs_manual_microsoft: user.rs_manual_microsoft,
      //     vo_manual_microsoft: user.vo_manual_microsoft
      //   }).then(val => {
      //     if (val.data && !val.data.success) {
      //       message.error(val.data.error_response)
      //     }
      //   }).catch((res) => {
      //     message.error((res.data && res.data.error_response) || "Please try again")
      //   });
      // }

      // if (user.user_type === "EA" && this.state.agency && this.state.agency.id) {
      //   axios.put("/api/agencies/" + this.state.agency.id, {
      //     name: agency.name,
      //     address: user.address,
      //   });
      //   axios.put("/api/nullify_bfiles_by_agency_id",{"agency_id": this.state.agency.id});
      // }
    }
  };
  requestPassword = () => {
    const { user } = this.state;
    this.setState({ loading: true });
    axios
      .post("/api/request_reset_password", { email: user.email })
      .then((res) => {
        this.setState({ loading: false });
        if (typeof res.data.error !== "undefined") {
          message.error(F.translate(`Can't send password request.`));
        } else {
          message.success(F.translate(`Password request sent.`));
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error(F.translate(`Can't send password request.`));
      });
  };
  logoutCalendly = () => {
    const { user } = this.state;
    this.setState({ loading: true });
    axios
      .put("/api/users/" + user.id, {
        calendly_access_token: null,
        calendly_refresh_token: null,
        calendly_expires_in: null,
        calendly_rs_setup_appointment: null,
        calendly_vo_setup_appointment: null,
      })
      .then(() => {
        message.success(F.translate(`You have successfully logged out.`));
        this.setState({ loading: false, has_calendly: false });
      });
  };

  fileAttributes_upload = (name, val) => {
    if (val && val[name].length === 0) {
      this.setState({
        fileAttributes: {
          ...this.state.fileAttributes,
          [name]: [],
        },
        tempfileAttributes: {
          ...this.state.tempfileAttributes,
          [name]: [],
        },
        cropModalOpen: false,
      });
    } else {
      this.setState({
        fileAttributes: {
          ...this.state.fileAttributes,
          [name]: val[name],
        },
        tempfileAttributes: val,
        fileAttributesCurrentSelected: name,
        cropModalOpen: true,
      });
    }
  };


  reset_temp_fileAttributes_upload = () => {
    this.setState({
      cropModalOpen: false,
      tempfileAttributes: {
        profile_pic: [],
        agency_photo: [],
      },
    });
  };

  render() {
    const { loading, user, card, agency } = this.state;
    const updateField = this.updateField;
    const updateCCField = this.updateCCField;
    const updateAgencyField = this.updateAgencyField;
    const update_appointment_hours = this.update_appointment_hours;
    const logoutCalendly = this.logoutCalendly;
    const parentInstance = this;


    return (
      <div>
        {user.user_type === "EA" ? (
          <EAProfile
            loading={loading}
            user={user}
            card={card}
            agency={agency}
            requestPassword={this.requestPassword}
            updateField={updateField}
            updateCCField={updateCCField}
            updateAgencyField={updateAgencyField}
            update={this.update.bind(this)}
            change_payment_method={this.state.change_payment_method}
            show_payment_method={() =>
              this.setState({ change_payment_method: true })
            }
            appointment_hours={this.state.appointment_hours}
            update_appointment_hours={update_appointment_hours}
            calendly_event_types={this.state.calendly_event_types}
            has_calendly={this.state.has_calendly}
            logoutCalendly={logoutCalendly}
            fileAttributes={this.state.fileAttributes}
            fileAttributes_upload={(name, val) =>
              this.fileAttributes_upload(name, val)
            }
            refreshData={{
              loadingData: this.loadingData,
              loadingState: (val) => this.setState({ loading: val }),
            }}
            parentInstance={parentInstance}
          // schedule_meetings={this.state.schedule_meetings}
          />
        ) : null}
        {user.user_type === "LSP" ? (
          <LSPProfile
            loading={loading}
            user={user}
            agency={agency}
            updateField={updateField}
            update={this.update.bind(this)}
            requestPassword={this.requestPassword}
            appointment_hours={this.state.appointment_hours}
            update_appointment_hours={update_appointment_hours}
            calendly_event_types={this.state.calendly_event_types}
            has_calendly={this.state.has_calendly}
            logoutCalendly={logoutCalendly}
            fileAttributes={this.state.fileAttributes}
            fileAttributes_upload={(name, val) =>
              this.fileAttributes_upload(name, val)
            }
            refreshData={{
              loadingData: this.loadingData,
              loadingState: (val) => this.setState({ loading: val }),
            }}
            parentInstance={parentInstance}
          />
        ) : null}
        {user.user_type === "AGENCY_MANAGER" ? (
          <AgencyManagerProfile
            loading={loading}
            user={user}
            agency={agency}
            updateField={updateField}
            update={this.update.bind(this)}
            requestPassword={this.requestPassword}
            fileAttributes={this.state.fileAttributes}
            fileAttributes_upload={(name, val) =>
              this.fileAttributes_upload(name, val)
            }
          />
        ) : null}
        {user.user_type !== "EA" &&
          user.user_type !== "LSP" &&
          user.user_type !== "AGENCY_MANAGER" ? (
          <DefaultProfile
            loading={loading}
            user={user}
            updateField={updateField}
            update={this.update.bind(this)}
            requestPassword={this.requestPassword}
          />
        ) : null}
        {this.state.cropModalOpen &&
          this.state.tempfileAttributes[
          this.state.fileAttributesCurrentSelected
          ] &&
          this.state.tempfileAttributes[
            this.state.fileAttributesCurrentSelected
          ].length && (
            <Crop_modal
              cropModalOpen={this.state.cropModalOpen}
              closeCropModalOpen={() => this.reset_temp_fileAttributes_upload()}
              fileAttributes={this.state.tempfileAttributes}
              fileAttributesCurrentSelected={
                this.state.fileAttributesCurrentSelected
              }
              fileAttributes_upload={(name, val) =>
                this.setState(
                  {
                    fileAttributes: {
                      ...this.state.fileAttributes,  // NOSONAR
                      [name]: val,
                    },
                  },
                  () => {
                    this.reset_temp_fileAttributes_upload();
                  }
                )
              }
            />
          )}
      </div>
    );
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./src/scenes/Profile/index.js